import React, { useEffect, useState } from 'react'

import { dismissAlertForToday } from 'features/AccountAlerts/utils/dismissedAlerts'
import { useRouter } from 'next/router'

import ModalSurveyNPS from './index'

/**
 * Abre a pesquisa de NPS quando a URL contém `open_nps=true`, que é o que o
 * botão "Responder pesquisa" do banner de avisos da conta faz.
 *
 * SC-11817: o modal não abre mais sozinho na visão geral. Quem tem a pesquisa
 * aberta vê o aviso no banner (1x por dia) e o ícone na topbar (NPSButton).
 */
const NPSSurveyTrigger = () => {
  const router = useRouter()

  const [isModalOpen, setIsModalOpen] = useState(false)

  useEffect(() => {
    if (router.query.open_nps !== 'true') return

    setIsModalOpen(true)

    const nextQuery = { ...router.query }
    delete nextQuery.open_nps
    router.replace({ pathname: router.pathname, query: nextQuery }, undefined, {
      shallow: true
    })
  }, [router.query.open_nps])

  const handleClose = () => {
    setIsModalOpen(false)

    // Abriu pelo banner e fechou: o aviso some até amanhã. Se respondeu, a API
    // já desligou o show_nps e o aviso não volta mais.
    dismissAlertForToday('nps_survey')
  }

  if (!isModalOpen) return null

  return <ModalSurveyNPS open={isModalOpen} onClose={handleClose} />
}

export default NPSSurveyTrigger
